export const SET_LEFT_MENU = "SET_LEFT_MENU";

export const setMenuState = (active) => ({
    type: SET_LEFT_MENU,
    active
});


export const dispatchMenuState = (active) => (dispatch, getState) =>  {
	let { leftMenu } = getState();
	if(active !== leftMenu.active){
			dispatch(setMenuState(active));
	}
}
